import { render, staticRenderFns } from "./os.vue?vue&type=template&id=7996b5bb&scoped=true&"
import script from "./os.vue?vue&type=script&lang=js&"
export * from "./os.vue?vue&type=script&lang=js&"
import style0 from "./os.vue?vue&type=style&index=0&id=7996b5bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7996b5bb",
  null
  
)

export default component.exports